// stores/fileRedirect.ts - 跨页面文件重定向（仅客户端内存缓存）
import { defineStore } from 'pinia'

export interface RedirectMeta {
  from?: string
  target?: string
  ts?: number
}

export const useFileRedirectStore = defineStore('fileRedirect', {
  state: () => ({
    pendingFile: null as File | null,
    meta: null as RedirectMeta | null
  }),
  actions: {
    setPending(file: File, meta?: RedirectMeta) {
      if (import.meta.server) return
      this.pendingFile = file
      this.meta = { ...(meta || {}), ts: Date.now() }
    },
    consumePending(): { file: File; meta: RedirectMeta | null } | null {
      if (import.meta.server) return null
      const f = this.pendingFile
      const m = this.meta
      this.pendingFile = null
      this.meta = null
      return f ? { file: f, meta: m } : null
    },
    clear() {
      if (import.meta.server) return
      this.pendingFile = null
      this.meta = null
    }
  }
})

